import { Tooltip, useTheme } from '@mui/material';
import { AlarmPriority } from 'src/types/alarms';
import { StyledLabelTagBox, StyledLabelTagValue } from './style';
import { useLocation } from 'react-router-dom';
import { useResponsive } from 'src/hooks/useResponsive';

type Props = {
  alarmPriority: AlarmPriority;
  value: number;
  tagName: string;
  isLiftStationMobile?: boolean;
};

export const LabelTagBox = ({ alarmPriority, value, isLiftStationMobile, tagName }: Props) => {
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useResponsive('down', 'md');
  const isSitesManagementRoute = location.pathname.includes('/sites-management');

  const backgroundColors = {
    Critical: theme.palette.error.lighter,
    Warning: theme.palette.warning.lighter,
    Info: theme.palette.info.lighter,
    Cleared: theme.palette.success.lighter,
    null: theme.palette.grey[300],
    Offline: theme.palette.error.lighter,
  };

  const colors = {
    Critical: theme.palette.error.main,
    Warning: theme.palette.warning.main,
    Info: theme.palette.info.main,
    Cleared: theme.palette.success.main,
    null: theme.palette.grey[500],
    Offline: theme.palette.error.main,
  };

  const borderColor = alarmPriority === 'null' ? 'transparent' : colors[alarmPriority];

  const stringValue = String(value);
  const maxLength = isSitesManagementRoute && isMobile ? 10 : 25;
  const displayValue =
    stringValue.length > maxLength ? `${stringValue.slice(0, maxLength)}` : stringValue;

  return (
    <Tooltip
      title={`${value}`}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: '#fff',
          },
        },
      }}
    >
      <StyledLabelTagBox
        isLiftStationMobile={isLiftStationMobile}
        background={backgroundColors[alarmPriority]}
        color={borderColor}
        data-sm={`${backgroundColors[alarmPriority]}-${tagName}`}
      >
        <StyledLabelTagValue
          data-sm="label-tag"
          isLiftStationMobile={isLiftStationMobile}
          color={colors[alarmPriority]}
        >
          {displayValue}
        </StyledLabelTagValue>
      </StyledLabelTagBox>
    </Tooltip>
  );
};
